export default {
  'clocks': [
    'clock0900_1100',
    'clock1100_1300',
    'clock1400_1600',
    'clock1600_1800'
  ]
}
